import { render } from "./TestResultGuideForYBMClassEngProduct.vue?vue&type=template&id=6b2a05fc&scoped=true"
import script from "./TestResultGuideForYBMClassEngProduct.vue?vue&type=script&lang=js"
export * from "./TestResultGuideForYBMClassEngProduct.vue?vue&type=script&lang=js"

import "./TestResultGuideForYBMClassEngProduct.vue?vue&type=style&index=0&id=6b2a05fc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2a05fc"]])

export default __exports__